// What a found thing looks like in the world, by kind, until Sam's
// trinket models land (trinket_<kind> nodes in a glb, see ASSETS.md).
//
// Pure and out here so the shelf at his roost and the pictures of what he
// carries (components/ui/bagPictures.js) draw the same shape for the same
// kind, and so it can be tested without a renderer. `shape` is a primitive the components know how to build;
// `size` is its longest side in metres, so a marble is a marble and a
// toy car is a toy car; `colour` is the default when the sim sends none.

export const TRINKET_LOOK = {
  bottlecap: { shape: 'disc', size: 0.11, colour: '#c0392b' },
  feather: { shape: 'blade', size: 0.18, colour: '#9aa3ad' },
  key: { shape: 'bar', size: 0.13, colour: '#c9a227' },
  shell: { shape: 'dome', size: 0.12, colour: '#f1e4d0' },
  marble: { shape: 'ball', size: 0.08, colour: '#3fa06b' },
  bolt: { shape: 'bar', size: 0.1, colour: '#7a4a12' },
  coin: { shape: 'disc', size: 0.08, colour: '#d9b45c' },
  button: { shape: 'disc', size: 0.07, colour: '#2c3e50' },
  pebble: { shape: 'ball', size: 0.1, colour: '#2b2b2b' },
  watch: { shape: 'disc', size: 0.12, colour: '#8e8e8e' },
  toycar: { shape: 'block', size: 0.15, colour: '#2e86de' },
  lens: { shape: 'ring', size: 0.11, colour: '#bfe3f0' },
}
const UNKNOWN = { shape: 'ball', size: 0.09, colour: '#888888' }

/** The look for a kind, with the sim's colour when it sends one. */
export function trinketLook(kind, colour = null) {
  const base = TRINKET_LOOK[String(kind || '')] || UNKNOWN
  return { ...base, colour: /^#[0-9a-f]{6}$/i.test(String(colour || '')) ? colour : base.colour }
}

/**
 * Where the n-th kept thing sits on the shelf, in shelf-local metres: two
 * loose rows, a little jitter that is the same every load (seeded by the
 * slot), so the pile looks put down by a bird rather than by a grid.
 */
export function shelfSpot(slot) {
  const i = Math.max(0, Math.floor(Number(slot) || 0))
  const row = i % 2
  const col = Math.floor(i / 2)
  const jx = ((i * 7919) % 100) / 100 - 0.5
  const jz = ((i * 104729) % 100) / 100 - 0.5
  return { x: -0.55 + col * 0.19 + jx * 0.05, z: (row ? 0.11 : -0.11) + jz * 0.05, rot: jx * 1.4 }
}
